export default __webpack_public_path__ + "b5305047359f66e452d44b66ecd89365.svg";